import { SET_KIOSK_PROFILE} from './actionTypes';
import { KioskProfileSettings } from '../../modules/kiosk/models/models';

export const setSelectedKioskProfile = (data: KioskProfileSettings) => {
    return {
        type: SET_KIOSK_PROFILE,
        data
    };
};